<template>
  <div class="pt-5 mt-7">
    <div class="mb-6">
      <h2>{{$tc('CONTENT.assets.asset', 2)}}</h2>
    </div>
    <template v-for="(item, index) in allAssetsIdForCurrentContract">
      <div class="b-contract__section mb-10" :key="index">
        <AssetGroup
          :assetsCount="allAssetsIdForCurrentContract.length"
          :availableAssetIdsForGroup="availableAssetIds"
          :assetComponentByAssetId="getAssetComponentsByAssetId(item)"
          :validationErrors="validationErrors"
          @newAssetSelected="newAssetSelectedForGroup"
          @newAssetCreated="newAssetCreatedForGroup"
          @deleteAsset="onDeleteAsset"
        />
      </div>
    </template>

    <div class="b-contract__section" v-if="isShowCreateNewAsset">
      <div class="b-contract__section-inner p-6 pb-8">
        <CreateOrChooseAssetSmallWidget :isError="validationErrors[0] && validationErrors[0].includes('newAsset')" :availableAssetIds="availableAssetIds" @selectedAssetId="setSelectedAsset($event)" @createAssetId="onCreateAssetId"/>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-3">
        <button type="button" @click="addAsset" class="b-btn" data-cy="add-asset">
          <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
          {{$t('CONTENT.assets.add_asset')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AssetGroup from "./AssetGroup";
import AssetComponent from "../../../../../plugins/assetComponent/models/AssetComponent";
import CreateOrChooseAssetSmallWidget from '../../../../widgets/CreateOrChooseAssetSmallWidget'

export default {
  components: {
    AssetGroup,
    CreateOrChooseAssetSmallWidget
  },
  props: {
    validationErrors: {
      type: Array
    }
  },
  data() {
    return {
      availableAssetIds: [],
      isAddNewAsset: false,
    }
  },
  created() {
    if(this.availableAssetIds.length === 0) {
      this.availableAssetIds = this.getAssets;
    }
  },
  computed: {
    ...mapGetters("assetComponentsPlugin", ['getAllAssetComponents']),
    ...mapGetters(['getAssets']),
    assetComponents() {
      return this.getAllAssetComponents;
    },
    isShowCreateNewAsset() {
      return this.allAssetsIdForCurrentContract.length === 0 || this.isAddNewAsset;
    },
    allAssetsIdForCurrentContract() {
      let allAssetIds = this.assetComponents.map(a => a.assetId);
      return [...new Set(allAssetIds)];
    },
  },
  methods: {
    onDeleteAsset(deletedAssetId) {
      const deletedAsset = this.getAssets.find(a => a.idInDB === deletedAssetId);
      this.availableAssetIds.push(deletedAsset);
    },
    newAssetSelectedForGroup(data) {
      // Return previous asset to collection
      const oldAsset = this.getAssets.find(a => a.idInDB === data.old);
      const ckeckOldAsset = this.availableAssetIds.find(a=>a.idInDB === data.old);
      if (ckeckOldAsset === null) {
        this.availableAssetIds.push(oldAsset);
      }

      const choosenAsset = this.getAssets.find(a => a.idInDB === data.old);
      this.availableAssetIds.push(choosenAsset);

      // remove new selected asset from collection if exist
      const neededAsset = this.availableAssetIds.find(a=>a.idInDB === data.new);
      if (neededAsset !== null) {
        const neededAssetIndex = this.availableAssetIds.indexOf(neededAsset);
        this.availableAssetIds.splice(neededAssetIndex, 1);
      }
    },
    availableAssetIdsForChoosen() {
      let allAssetIds = this.getAssets;
      let currentChoosenAssetIds = this.getAllAssetIdsForCurrentContract();


      if(allAssetIds.length !== 0) {
        let availableAssetIds = [];

        for (let i = 0; i < allAssetIds.length; i++) {
          const element = allAssetIds[i].idInDB;
          const isContain = currentChoosenAssetIds.some(a => a === element);
          if(!isContain){
            availableAssetIds.push(allAssetIds[i]);
          }
        }
        return availableAssetIds;
      }

      return allAssetIds;

    },
    getAllAssetIdsForCurrentContract() {
      let allAssetIds = this.assetComponents.map(a => a.assetId);
      return [ ...new Set(allAssetIds)];
    },
    getAssetComponentsByAssetId(assetId) {
      return this.assetComponents.filter(c=>c.assetId === assetId);
    },
    addAsset() {
      this.isAddNewAsset = true;
    },
    setSelectedAsset(assetIdInfoObject) {
      const firstAssetComponent = AssetComponent.createNew();
      firstAssetComponent.assetId = +assetIdInfoObject.currentAssetId;
      this.$store.commit("assetComponentsPlugin/setNewAssetComponent", firstAssetComponent);
      this.isAddNewAsset = false;
      this.availableAssetIds = this.availableAssetIdsForChoosen();
    },

    newAssetCreatedForGroup(data) {
      const newAsset = this.getAssets.find(a => a.idInDB === data.new);
      const oldAsset = this.getAssets.find(a => a.idInDB === data.old);
      this.availableAssetIds.push(newAsset);

      const ckeckOldAsset = this.availableAssetIds.find(a=>a.idInDB === data.old);
      if (ckeckOldAsset === null) {
        this.availableAssetIds.push(oldAsset);
      }
    },

    onCreateAssetId(assetInfoObj) {
      const firstAssetComponent = AssetComponent.createNew();
      firstAssetComponent.assetId = +assetInfoObj.newAssetId;
      this.$store.commit("assetComponentsPlugin/setNewAssetComponent", firstAssetComponent);
      this.isAddNewAsset = false;
      this.availableAssetIds = this.availableAssetIdsForChoosen();
    }
  }
};
</script>
